import React, {Component} from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment-timezone';
import {connect} from 'react-redux';
import {
  fetchPaymentHistoryForCurrentUser,
  fetchProductBillingStatusesForCurrentUser,
} from '../../../../actions/usageStatus.actions';
import {withRouter} from 'react-router-dom';
import {Button, ButtonGroup, Table} from '../../../Common/PageComponents';

class PaymentAndUsageHistoryDateRangePicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: moment(),
      endDate: moment(),
    };
    this._setStartDate = this._setStartDate.bind(this);
    this._setEndDate = this._setEndDate.bind(this);
  }

  _submit(e) {
    e.preventDefault();
    let startDate = this.state.startDate.format('YYYY-MM-DD');
    let endDate = this.state.endDate.format('YYYY-MM-DD');
    let revisedEndDate = moment(endDate, 'YYYY-MM-DD')
      .add(1, 'days')
      .format('YYYY-MM-DD');

    this.props.dispatch(fetchPaymentHistoryForCurrentUser(startDate, revisedEndDate, 1));
    this.props.dispatch(fetchProductBillingStatusesForCurrentUser(startDate, revisedEndDate, 1));
    this.props.history.push('/my-pc-bang/usage-status/payment-and-billing/payment-history');
  }

  _setDateRangeSinceFirstDayOfMonth() {
    this._setStartDate(moment().startOf('month'));
    this._setEndDate(moment());
  }

  _setDateRangeSinceRecentThreeMonth() {
    this._setStartDate(moment().subtract(3, 'months'));
    this._setEndDate(moment());
  }

  _setStartDate(date) {
    this.setState({
      startDate: date,
    });
  }

  _setEndDate(date) {
    this.setState({
      endDate: date,
    });
  }

  render() {
    return (
      <div>
        <Table theme={'form'}>
          <colgroup>
            <col style={{width: '140px'}} />
            <col />
          </colgroup>
          <tbody>
            <tr>
              <th>기간별 조회</th>
              <td>
                <form>
                  <label style={{marginRight: '20px', lineHeight: 1}}>
                    <input
                      style={{verticalAlign: 'baseline', marginRight: '5px'}}
                      type="radio"
                      name="dateRange"
                      onClick={() => this._setDateRangeSinceFirstDayOfMonth()}
                    />
                    당월
                  </label>
                  <label>
                    <input
                      style={{verticalAlign: 'baseline', marginRight: '5px'}}
                      type="radio"
                      name="dateRange"
                      value="3"
                      onClick={() => this._setDateRangeSinceRecentThreeMonth()}
                    />
                    최근 3개월
                  </label>
                </form>
              </td>
            </tr>
            <tr>
              <th>일자별 조회</th>
              <td>
                <span style={{margin: '0 10px'}}>시작일</span>
                <DatePicker selected={this.state.startDate} onChange={this._setStartDate} />
                <span style={{margin: '0 0 0 10px'}}>-</span>
                <span style={{margin: '0 10px'}}>종료일</span>
                <DatePicker selected={this.state.endDate} onChange={this._setEndDate} />
              </td>
            </tr>
          </tbody>
        </Table>
        <ButtonGroup>
          <Button onClick={e => this._submit(e)}>조회하기</Button>
        </ButtonGroup>
      </div>
    );
  }
}

export default withRouter(connect()(PaymentAndUsageHistoryDateRangePicker));
